import React from 'react';
import { useIsDealershipPage } from '~/context/dealership/StaticContext';

type OwnProps = React.PropsWithChildren<{
  dealership?: boolean;
  operation?: 'and' | 'or';
}>;

export default function ShowConditionally(props: OwnProps) {
  const isDealership = useIsDealershipPage();

  const conditions = [[props.dealership, isDealership]];

  const filteredConditions = conditions.filter(
    ([condition]) => condition != null
  );

  const shouldShow =
    props.operation === 'or'
      ? filteredConditions.some(([condition, value]) => condition === value)
      : filteredConditions.every(([condition, value]) => condition === value);

  return shouldShow ? <>{props.children}</> : null;
}
